// Generated from ./util_cohort_builder_grammar/stable/EntityLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class EntityLexer extends antlr.Lexer {
    public static readonly CARE_SITE = 1;
    public static readonly CONDITION_OCCURRENCE = 2;
    public static readonly DRUG_EXPOSURE = 3;
    public static readonly MEASUREMENT = 4;
    public static readonly OBSERVATION = 5;
    public static readonly PERSON = 6;
    public static readonly PROCEDURE_OCCURRENCE = 7;
    public static readonly PROVIDER = 8;
    public static readonly VISIT_OCCURRENCE = 9;
    public static readonly QUALIFIED_CARE_SITE = 10;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 11;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 12;
    public static readonly QUALIFIED_MEASUREMENT = 13;
    public static readonly QUALIFIED_OBSERVATION = 14;
    public static readonly QUALIFIED_PERSON = 15;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 16;
    public static readonly QUALIFIED_PROVIDER = 17;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 18;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 19;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 20;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 21;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 22;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 23;
    public static readonly SUBJECT_VARIABLE_PERSON = 24;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 25;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 26;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 27;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'"
    ];

    public static readonly symbolicNames = [
        null, "CARE_SITE", "CONDITION_OCCURRENCE", "DRUG_EXPOSURE", "MEASUREMENT", 
        "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", "PROVIDER", "VISIT_OCCURRENCE", 
        "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", "QUALIFIED_DRUG_EXPOSURE", 
        "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", "QUALIFIED_PERSON", 
        "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", "QUALIFIED_VISIT_OCCURRENCE", 
        "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "CARE_SITE", "CONDITION_OCCURRENCE", "DRUG_EXPOSURE", "MEASUREMENT", 
        "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", "PROVIDER", "VISIT_OCCURRENCE", 
        "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", "QUALIFIED_DRUG_EXPOSURE", 
        "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", "QUALIFIED_PERSON", 
        "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", "QUALIFIED_VISIT_OCCURRENCE", 
        "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, EntityLexer._ATN, EntityLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "EntityLexer.g4"; }

    public get literalNames(): (string | null)[] { return EntityLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return EntityLexer.symbolicNames; }
    public get ruleNames(): string[] { return EntityLexer.ruleNames; }

    public get serializedATN(): number[] { return EntityLexer._serializedATN; }

    public get channelNames(): string[] { return EntityLexer.channelNames; }

    public get modeNames(): string[] { return EntityLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,27,667,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,
        2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,
        13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,
        19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,
        26,7,26,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,6,1,6,
        1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,
        1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,8,1,8,1,8,1,8,
        1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,9,1,9,1,9,
        1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,
        1,9,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,11,1,11,1,11,1,11,1,11,1,11,1,11,
        1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,
        1,11,1,11,1,11,1,11,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,
        1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,
        1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,
        1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,14,1,14,1,14,1,14,
        1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,
        1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,
        1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,
        1,15,1,15,1,15,1,15,1,15,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,
        1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,17,1,17,
        1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,
        1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,18,
        1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,
        1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,
        1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,
        1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,
        1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,
        1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,
        1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,22,1,22,1,22,1,22,1,22,1,22,
        1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,
        1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,23,1,23,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,25,1,25,1,25,1,25,1,25,1,25,
        1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,
        1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,0,0,27,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,
        11,23,12,25,13,27,14,29,15,31,16,33,17,35,18,37,19,39,20,41,21,43,
        22,45,23,47,24,49,25,51,26,53,27,1,0,0,666,0,1,1,0,0,0,0,3,1,0,0,
        0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,
        0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,0,23,1,0,0,0,
        0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,0,0,0,33,1,0,0,0,
        0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,0,43,1,0,0,0,
        0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,0,53,1,0,0,0,
        1,55,1,0,0,0,3,65,1,0,0,0,5,86,1,0,0,0,7,100,1,0,0,0,9,112,1,0,0,
        0,11,124,1,0,0,0,13,131,1,0,0,0,15,152,1,0,0,0,17,161,1,0,0,0,19,
        178,1,0,0,0,21,198,1,0,0,0,23,229,1,0,0,0,25,253,1,0,0,0,27,275,
        1,0,0,0,29,297,1,0,0,0,31,314,1,0,0,0,33,345,1,0,0,0,35,364,1,0,
        0,0,37,391,1,0,0,0,39,418,1,0,0,0,41,456,1,0,0,0,43,487,1,0,0,0,
        45,516,1,0,0,0,47,545,1,0,0,0,49,569,1,0,0,0,51,607,1,0,0,0,53,633,
        1,0,0,0,55,56,5,67,0,0,56,57,5,65,0,0,57,58,5,82,0,0,58,59,5,69,
        0,0,59,60,5,95,0,0,60,61,5,83,0,0,61,62,5,73,0,0,62,63,5,84,0,0,
        63,64,5,69,0,0,64,2,1,0,0,0,65,66,5,67,0,0,66,67,5,79,0,0,67,68,
        5,78,0,0,68,69,5,68,0,0,69,70,5,73,0,0,70,71,5,84,0,0,71,72,5,73,
        0,0,72,73,5,79,0,0,73,74,5,78,0,0,74,75,5,95,0,0,75,76,5,79,0,0,
        76,77,5,67,0,0,77,78,5,67,0,0,78,79,5,85,0,0,79,80,5,82,0,0,80,81,
        5,82,0,0,81,82,5,69,0,0,82,83,5,78,0,0,83,84,5,67,0,0,84,85,5,69,
        0,0,85,4,1,0,0,0,86,87,5,68,0,0,87,88,5,82,0,0,88,89,5,85,0,0,89,
        90,5,71,0,0,90,91,5,95,0,0,91,92,5,69,0,0,92,93,5,88,0,0,93,94,5,
        80,0,0,94,95,5,79,0,0,95,96,5,83,0,0,96,97,5,85,0,0,97,98,5,82,0,
        0,98,99,5,69,0,0,99,6,1,0,0,0,100,101,5,77,0,0,101,102,5,69,0,0,
        102,103,5,65,0,0,103,104,5,83,0,0,104,105,5,85,0,0,105,106,5,82,
        0,0,106,107,5,69,0,0,107,108,5,77,0,0,108,109,5,69,0,0,109,110,5,
        78,0,0,110,111,5,84,0,0,111,8,1,0,0,0,112,113,5,79,0,0,113,114,5,
        66,0,0,114,115,5,83,0,0,115,116,5,69,0,0,116,117,5,82,0,0,117,118,
        5,86,0,0,118,119,5,65,0,0,119,120,5,84,0,0,120,121,5,73,0,0,121,
        122,5,79,0,0,122,123,5,78,0,0,123,10,1,0,0,0,124,125,5,80,0,0,125,
        126,5,69,0,0,126,127,5,82,0,0,127,128,5,83,0,0,128,129,5,79,0,0,
        129,130,5,78,0,0,130,12,1,0,0,0,131,132,5,80,0,0,132,133,5,82,0,
        0,133,134,5,79,0,0,134,135,5,67,0,0,135,136,5,69,0,0,136,137,5,68,
        0,0,137,138,5,85,0,0,138,139,5,82,0,0,139,140,5,69,0,0,140,141,5,
        95,0,0,141,142,5,79,0,0,142,143,5,67,0,0,143,144,5,67,0,0,144,145,
        5,85,0,0,145,146,5,82,0,0,146,147,5,82,0,0,147,148,5,69,0,0,148,
        149,5,78,0,0,149,150,5,67,0,0,150,151,5,69,0,0,151,14,1,0,0,0,152,
        153,5,80,0,0,153,154,5,82,0,0,154,155,5,79,0,0,155,156,5,86,0,0,
        156,157,5,73,0,0,157,158,5,68,0,0,158,159,5,69,0,0,159,160,5,82,
        0,0,160,16,1,0,0,0,161,162,5,86,0,0,162,163,5,73,0,0,163,164,5,83,
        0,0,164,165,5,73,0,0,165,166,5,84,0,0,166,167,5,95,0,0,167,168,5,
        79,0,0,168,169,5,67,0,0,169,170,5,67,0,0,170,171,5,85,0,0,171,172,
        5,82,0,0,172,173,5,82,0,0,173,174,5,69,0,0,174,175,5,78,0,0,175,
        176,5,67,0,0,176,177,5,69,0,0,177,18,1,0,0,0,178,179,5,81,0,0,179,
        180,5,85,0,0,180,181,5,65,0,0,181,182,5,76,0,0,182,183,5,73,0,0,
        183,184,5,70,0,0,184,185,5,73,0,0,185,186,5,69,0,0,186,187,5,68,
        0,0,187,188,5,95,0,0,188,189,5,67,0,0,189,190,5,65,0,0,190,191,5,
        82,0,0,191,192,5,69,0,0,192,193,5,95,0,0,193,194,5,83,0,0,194,195,
        5,73,0,0,195,196,5,84,0,0,196,197,5,69,0,0,197,20,1,0,0,0,198,199,
        5,81,0,0,199,200,5,85,0,0,200,201,5,65,0,0,201,202,5,76,0,0,202,
        203,5,73,0,0,203,204,5,70,0,0,204,205,5,73,0,0,205,206,5,69,0,0,
        206,207,5,68,0,0,207,208,5,95,0,0,208,209,5,67,0,0,209,210,5,79,
        0,0,210,211,5,78,0,0,211,212,5,68,0,0,212,213,5,73,0,0,213,214,5,
        84,0,0,214,215,5,73,0,0,215,216,5,79,0,0,216,217,5,78,0,0,217,218,
        5,95,0,0,218,219,5,79,0,0,219,220,5,67,0,0,220,221,5,67,0,0,221,
        222,5,85,0,0,222,223,5,82,0,0,223,224,5,82,0,0,224,225,5,69,0,0,
        225,226,5,78,0,0,226,227,5,67,0,0,227,228,5,69,0,0,228,22,1,0,0,
        0,229,230,5,81,0,0,230,231,5,85,0,0,231,232,5,65,0,0,232,233,5,76,
        0,0,233,234,5,73,0,0,234,235,5,70,0,0,235,236,5,73,0,0,236,237,5,
        69,0,0,237,238,5,68,0,0,238,239,5,95,0,0,239,240,5,68,0,0,240,241,
        5,82,0,0,241,242,5,85,0,0,242,243,5,71,0,0,243,244,5,95,0,0,244,
        245,5,69,0,0,245,246,5,88,0,0,246,247,5,80,0,0,247,248,5,79,0,0,
        248,249,5,83,0,0,249,250,5,85,0,0,250,251,5,82,0,0,251,252,5,69,
        0,0,252,24,1,0,0,0,253,254,5,81,0,0,254,255,5,85,0,0,255,256,5,65,
        0,0,256,257,5,76,0,0,257,258,5,73,0,0,258,259,5,70,0,0,259,260,5,
        73,0,0,260,261,5,69,0,0,261,262,5,68,0,0,262,263,5,95,0,0,263,264,
        5,77,0,0,264,265,5,69,0,0,265,266,5,65,0,0,266,267,5,83,0,0,267,
        268,5,85,0,0,268,269,5,82,0,0,269,270,5,69,0,0,270,271,5,77,0,0,
        271,272,5,69,0,0,272,273,5,78,0,0,273,274,5,84,0,0,274,26,1,0,0,
        0,275,276,5,81,0,0,276,277,5,85,0,0,277,278,5,65,0,0,278,279,5,76,
        0,0,279,280,5,73,0,0,280,281,5,70,0,0,281,282,5,73,0,0,282,283,5,
        69,0,0,283,284,5,68,0,0,284,285,5,95,0,0,285,286,5,79,0,0,286,287,
        5,66,0,0,287,288,5,83,0,0,288,289,5,69,0,0,289,290,5,82,0,0,290,
        291,5,86,0,0,291,292,5,65,0,0,292,293,5,84,0,0,293,294,5,73,0,0,
        294,295,5,79,0,0,295,296,5,78,0,0,296,28,1,0,0,0,297,298,5,81,0,
        0,298,299,5,85,0,0,299,300,5,65,0,0,300,301,5,76,0,0,301,302,5,73,
        0,0,302,303,5,70,0,0,303,304,5,73,0,0,304,305,5,69,0,0,305,306,5,
        68,0,0,306,307,5,95,0,0,307,308,5,80,0,0,308,309,5,69,0,0,309,310,
        5,82,0,0,310,311,5,83,0,0,311,312,5,79,0,0,312,313,5,78,0,0,313,
        30,1,0,0,0,314,315,5,81,0,0,315,316,5,85,0,0,316,317,5,65,0,0,317,
        318,5,76,0,0,318,319,5,73,0,0,319,320,5,70,0,0,320,321,5,73,0,0,
        321,322,5,69,0,0,322,323,5,68,0,0,323,324,5,95,0,0,324,325,5,80,
        0,0,325,326,5,82,0,0,326,327,5,79,0,0,327,328,5,67,0,0,328,329,5,
        69,0,0,329,330,5,68,0,0,330,331,5,85,0,0,331,332,5,82,0,0,332,333,
        5,69,0,0,333,334,5,95,0,0,334,335,5,79,0,0,335,336,5,67,0,0,336,
        337,5,67,0,0,337,338,5,85,0,0,338,339,5,82,0,0,339,340,5,82,0,0,
        340,341,5,69,0,0,341,342,5,78,0,0,342,343,5,67,0,0,343,344,5,69,
        0,0,344,32,1,0,0,0,345,346,5,81,0,0,346,347,5,85,0,0,347,348,5,65,
        0,0,348,349,5,76,0,0,349,350,5,73,0,0,350,351,5,70,0,0,351,352,5,
        73,0,0,352,353,5,69,0,0,353,354,5,68,0,0,354,355,5,95,0,0,355,356,
        5,80,0,0,356,357,5,82,0,0,357,358,5,79,0,0,358,359,5,86,0,0,359,
        360,5,73,0,0,360,361,5,68,0,0,361,362,5,69,0,0,362,363,5,82,0,0,
        363,34,1,0,0,0,364,365,5,81,0,0,365,366,5,85,0,0,366,367,5,65,0,
        0,367,368,5,76,0,0,368,369,5,73,0,0,369,370,5,70,0,0,370,371,5,73,
        0,0,371,372,5,69,0,0,372,373,5,68,0,0,373,374,5,95,0,0,374,375,5,
        86,0,0,375,376,5,73,0,0,376,377,5,83,0,0,377,378,5,73,0,0,378,379,
        5,84,0,0,379,380,5,95,0,0,380,381,5,79,0,0,381,382,5,67,0,0,382,
        383,5,67,0,0,383,384,5,85,0,0,384,385,5,82,0,0,385,386,5,82,0,0,
        386,387,5,69,0,0,387,388,5,78,0,0,388,389,5,67,0,0,389,390,5,69,
        0,0,390,36,1,0,0,0,391,392,5,83,0,0,392,393,5,85,0,0,393,394,5,66,
        0,0,394,395,5,74,0,0,395,396,5,69,0,0,396,397,5,67,0,0,397,398,5,
        84,0,0,398,399,5,95,0,0,399,400,5,86,0,0,400,401,5,65,0,0,401,402,
        5,82,0,0,402,403,5,73,0,0,403,404,5,65,0,0,404,405,5,66,0,0,405,
        406,5,76,0,0,406,407,5,69,0,0,407,408,5,95,0,0,408,409,5,67,0,0,
        409,410,5,65,0,0,410,411,5,82,0,0,411,412,5,69,0,0,412,413,5,95,
        0,0,413,414,5,83,0,0,414,415,5,73,0,0,415,416,5,84,0,0,416,417,5,
        69,0,0,417,38,1,0,0,0,418,419,5,83,0,0,419,420,5,85,0,0,420,421,
        5,66,0,0,421,422,5,74,0,0,422,423,5,69,0,0,423,424,5,67,0,0,424,
        425,5,84,0,0,425,426,5,95,0,0,426,427,5,86,0,0,427,428,5,65,0,0,
        428,429,5,82,0,0,429,430,5,73,0,0,430,431,5,65,0,0,431,432,5,66,
        0,0,432,433,5,76,0,0,433,434,5,69,0,0,434,435,5,95,0,0,435,436,5,
        67,0,0,436,437,5,79,0,0,437,438,5,78,0,0,438,439,5,68,0,0,439,440,
        5,73,0,0,440,441,5,84,0,0,441,442,5,73,0,0,442,443,5,79,0,0,443,
        444,5,78,0,0,444,445,5,95,0,0,445,446,5,79,0,0,446,447,5,67,0,0,
        447,448,5,67,0,0,448,449,5,85,0,0,449,450,5,82,0,0,450,451,5,82,
        0,0,451,452,5,69,0,0,452,453,5,78,0,0,453,454,5,67,0,0,454,455,5,
        69,0,0,455,40,1,0,0,0,456,457,5,83,0,0,457,458,5,85,0,0,458,459,
        5,66,0,0,459,460,5,74,0,0,460,461,5,69,0,0,461,462,5,67,0,0,462,
        463,5,84,0,0,463,464,5,95,0,0,464,465,5,86,0,0,465,466,5,65,0,0,
        466,467,5,82,0,0,467,468,5,73,0,0,468,469,5,65,0,0,469,470,5,66,
        0,0,470,471,5,76,0,0,471,472,5,69,0,0,472,473,5,95,0,0,473,474,5,
        68,0,0,474,475,5,82,0,0,475,476,5,85,0,0,476,477,5,71,0,0,477,478,
        5,95,0,0,478,479,5,69,0,0,479,480,5,88,0,0,480,481,5,80,0,0,481,
        482,5,79,0,0,482,483,5,83,0,0,483,484,5,85,0,0,484,485,5,82,0,0,
        485,486,5,69,0,0,486,42,1,0,0,0,487,488,5,83,0,0,488,489,5,85,0,
        0,489,490,5,66,0,0,490,491,5,74,0,0,491,492,5,69,0,0,492,493,5,67,
        0,0,493,494,5,84,0,0,494,495,5,95,0,0,495,496,5,86,0,0,496,497,5,
        65,0,0,497,498,5,82,0,0,498,499,5,73,0,0,499,500,5,65,0,0,500,501,
        5,66,0,0,501,502,5,76,0,0,502,503,5,69,0,0,503,504,5,95,0,0,504,
        505,5,77,0,0,505,506,5,69,0,0,506,507,5,65,0,0,507,508,5,83,0,0,
        508,509,5,85,0,0,509,510,5,82,0,0,510,511,5,69,0,0,511,512,5,77,
        0,0,512,513,5,69,0,0,513,514,5,78,0,0,514,515,5,84,0,0,515,44,1,
        0,0,0,516,517,5,83,0,0,517,518,5,85,0,0,518,519,5,66,0,0,519,520,
        5,74,0,0,520,521,5,69,0,0,521,522,5,67,0,0,522,523,5,84,0,0,523,
        524,5,95,0,0,524,525,5,86,0,0,525,526,5,65,0,0,526,527,5,82,0,0,
        527,528,5,73,0,0,528,529,5,65,0,0,529,530,5,66,0,0,530,531,5,76,
        0,0,531,532,5,69,0,0,532,533,5,95,0,0,533,534,5,79,0,0,534,535,5,
        66,0,0,535,536,5,83,0,0,536,537,5,69,0,0,537,538,5,82,0,0,538,539,
        5,86,0,0,539,540,5,65,0,0,540,541,5,84,0,0,541,542,5,73,0,0,542,
        543,5,79,0,0,543,544,5,78,0,0,544,46,1,0,0,0,545,546,5,83,0,0,546,
        547,5,85,0,0,547,548,5,66,0,0,548,549,5,74,0,0,549,550,5,69,0,0,
        550,551,5,67,0,0,551,552,5,84,0,0,552,553,5,95,0,0,553,554,5,86,
        0,0,554,555,5,65,0,0,555,556,5,82,0,0,556,557,5,73,0,0,557,558,5,
        65,0,0,558,559,5,66,0,0,559,560,5,76,0,0,560,561,5,69,0,0,561,562,
        5,95,0,0,562,563,5,80,0,0,563,564,5,69,0,0,564,565,5,82,0,0,565,
        566,5,83,0,0,566,567,5,79,0,0,567,568,5,78,0,0,568,48,1,0,0,0,569,
        570,5,83,0,0,570,571,5,85,0,0,571,572,5,66,0,0,572,573,5,74,0,0,
        573,574,5,69,0,0,574,575,5,67,0,0,575,576,5,84,0,0,576,577,5,95,
        0,0,577,578,5,86,0,0,578,579,5,65,0,0,579,580,5,82,0,0,580,581,5,
        73,0,0,581,582,5,65,0,0,582,583,5,66,0,0,583,584,5,76,0,0,584,585,
        5,69,0,0,585,586,5,95,0,0,586,587,5,80,0,0,587,588,5,82,0,0,588,
        589,5,79,0,0,589,590,5,67,0,0,590,591,5,69,0,0,591,592,5,68,0,0,
        592,593,5,85,0,0,593,594,5,82,0,0,594,595,5,69,0,0,595,596,5,95,
        0,0,596,597,5,79,0,0,597,598,5,67,0,0,598,599,5,67,0,0,599,600,5,
        85,0,0,600,601,5,82,0,0,601,602,5,82,0,0,602,603,5,69,0,0,603,604,
        5,78,0,0,604,605,5,67,0,0,605,606,5,69,0,0,606,50,1,0,0,0,607,608,
        5,83,0,0,608,609,5,85,0,0,609,610,5,66,0,0,610,611,5,74,0,0,611,
        612,5,69,0,0,612,613,5,67,0,0,613,614,5,84,0,0,614,615,5,95,0,0,
        615,616,5,86,0,0,616,617,5,65,0,0,617,618,5,82,0,0,618,619,5,73,
        0,0,619,620,5,65,0,0,620,621,5,66,0,0,621,622,5,76,0,0,622,623,5,
        69,0,0,623,624,5,95,0,0,624,625,5,80,0,0,625,626,5,82,0,0,626,627,
        5,79,0,0,627,628,5,86,0,0,628,629,5,73,0,0,629,630,5,68,0,0,630,
        631,5,69,0,0,631,632,5,82,0,0,632,52,1,0,0,0,633,634,5,83,0,0,634,
        635,5,85,0,0,635,636,5,66,0,0,636,637,5,74,0,0,637,638,5,69,0,0,
        638,639,5,67,0,0,639,640,5,84,0,0,640,641,5,95,0,0,641,642,5,86,
        0,0,642,643,5,65,0,0,643,644,5,82,0,0,644,645,5,73,0,0,645,646,5,
        65,0,0,646,647,5,66,0,0,647,648,5,76,0,0,648,649,5,69,0,0,649,650,
        5,95,0,0,650,651,5,86,0,0,651,652,5,73,0,0,652,653,5,83,0,0,653,
        654,5,73,0,0,654,655,5,84,0,0,655,656,5,95,0,0,656,657,5,79,0,0,
        657,658,5,67,0,0,658,659,5,67,0,0,659,660,5,85,0,0,660,661,5,82,
        0,0,661,662,5,82,0,0,662,663,5,69,0,0,663,664,5,78,0,0,664,665,5,
        67,0,0,665,666,5,69,0,0,666,54,1,0,0,0,1,0,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!EntityLexer.__ATN) {
            EntityLexer.__ATN = new antlr.ATNDeserializer().deserialize(EntityLexer._serializedATN);
        }

        return EntityLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(EntityLexer.literalNames, EntityLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return EntityLexer.vocabulary;
    }

    private static readonly decisionsToDFA = EntityLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}